import { ConvertBaseStorage } from "@/services/storage/base/convert-base-storage";
import { DuetsSettings } from "@/components/pages/duets/providers/duets-provider";
import { DuetConfig } from "@/components/pages/duets/hooks/use-start-duet";
import {
  DuetsSettingsField,
  DuetsSettingsStorageMixin,
} from "@/services/storage/storage-mixins/settings-mixins/duets-settings-storage-mixin";

class DuetsSessionStorage extends ConvertBaseStorage<
  DuetsSettings,
  DuetConfig,
  DuetsSettingsField,
  DuetsSettingsStorageMixin
> {
  settingStorage: DuetsSettingsStorageMixin;

  constructor() {
    super("duetsCache", "DuetsDB");

    this.settingStorage = new DuetsSettingsStorageMixin(
      this.storeName,
      this.databaseName,
    );
  }

  protected setDataFromStorageInternal(
    sessionSettings: any,
  ): Record<string, any> {
    return { models: sessionSettings?.models ?? [] };
  }
}

const duetsSessionStorage = new DuetsSessionStorage();
export { duetsSessionStorage };
